import { getImageAsset } from '@acorns/web-utils'

const getImagePath = (name: string): string => {
  return getImageAsset(`/family/recap/${name}`, 'svg').url
}

export default getImagePath
